import { render, staticRenderFns } from "./AppFileEditor.vue?vue&type=template&id=21f31fc2&scoped=true&"
import script from "./AppFileEditor.vue?vue&type=script&lang=js&"
export * from "./AppFileEditor.vue?vue&type=script&lang=js&"
import style0 from "./AppFileEditor.vue?vue&type=style&index=0&id=21f31fc2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f31fc2",
  null
  
)

export default component.exports